import { useAuth0 } from "@auth0/auth0-react";
import '../Css/Loginsetup.css'
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import React from "react";
import mloimg from './image/Mlogo.png'
// import lovideo from  './Video/video (1080p).mp4'

function Loginsetup(){
    useEffect(()=>{
        Aos.init({duration:2000})
        },[])
        useEffect(()=>{
            document.title="Montukharb's.com"
        })
    const { loginWithRedirect } = useAuth0();
 return (
    <div>
        
    <div id="Loginsetupmain"  >
    <div id="imgdiv">
            <img src={mloimg} id="mlogimg" alt="Company logo"/>
        </div>
       
    </div>
    <div id="btnid">
<button id="firstpageonclick" data-aos="slide-down" onClick={() => loginWithRedirect()}>Log In</button>
</div>
    <div className="Loginfotter">
     <h6 className="Loginfottertext"> Copyright &#169; 2023.All rights reserved &#174;. Devloped By :<span id="Loginteam"> Code Hacked Team</span></h6>
    </div>
    {/* <div>
   <video src={lovideo} autoPlay muted loop type="video/mp4,video/webm"/>
    </div> */}
    </div>
 )
}
export default Loginsetup;